// extracted by mini-css-extract-plugin
export var growableInput = "_9a-0";
export var tagContainer = "_9a-2";
export var textInput = "_9a-1";